import { useEffect, useState } from "react";

import { Outlet, useLocation, useNavigate } from "react-router-dom"




import classes from "./company.module.css";
import NavTabs from "../../Components/salariesSettings/NavTabs";
;


const SalariesSettings = () => {
    const [activeTab ,setActiveTab] = useState("salary") 
    const navigate =useNavigate()
    const location =useLocation()
    useEffect(()=>{ 
       const path = location.pathname.split("/salariesSettings/").pop()
       setActiveTab(path)
    },[location])
    const handleActiveTab =(tab ,route)=>{
    
      setActiveTab(tab)  
      navigate(route)
    }    
  return (   
    <div className={classes.container}>
      <div className={classes.RowTabs}>
        <NavTabs handleActiveTab={handleActiveTab} activeTab={activeTab}/>
        <div className={classes.TabsContent}>
        <Outlet/>
        </div>
      </div>
    </div>
  );
};

export default SalariesSettings;
